import { pixelSizeHelperPortalUi } from '../../../utils/pixelSizeHelper';

export const OPTION_HEIGHT = 34;

/**
 * Pixel equivalent of the SCSS `em(6)` top/bottom spacing around the options
 * list. With virtualized absolute positioning the CSS :first-child/:last-child
 * margins can't be used, so we apply this as padding on the virtualizer
 * container and offset each item's translateY by the same amount.
 */
export const OPTION_LIST_PADDING = pixelSizeHelperPortalUi(6);
